export default "__VITE_ASSET__BJdOyfCU__"